const sampleFormProducts = {
	state: () => ({
		sampleProducts: [],
	}),
	getters: {
		getSampleProducts: (state) => {
			return state.sampleProducts;
		}
	},
	mutations: {
		setSampleProducts: (state, products) => {
			state.sampleProducts = products;
		}
	},
};

export default sampleFormProducts;
